import AddressForm from './AddressForm';

function App() {
  return <AddressForm />;
}

export default App;